import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table, CardBody } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    getCourse, getProgramme, getGender, getCasteCategory, getStudentDetails, getLastQualifyingDetails, getUniversityboard, getDocumentByStudentID,
    updateLastQualifying, getBloodGroup, getMaritalData, getNationality, getReligion, updatestudentdetails, fetchStudentPhoto, fetchStudentSign, fetchSubjectbyStudentID
} from "../../../api/updatestudentdetails";
import {
    Document, Page, Text, View, PDFDownloadLink, Font, Image, StyleSheet,
    Table as PDFTable,
} from '@react-pdf/renderer';

Font.register({
    family: 'RobotoSlabBold',
    src: '/fonts/Roboto-Bold.ttf'
});

Font.register({
    family: 'RobotoSlabRegular',
    src: '/fonts/Roboto-Regular.ttf'
});

Font.register({
    family: 'NunitoBold',
    src: 'fonts/Nunito-Bold.ttf'
});

Font.register({
    family: 'NunitoRegular',
    src: '/fonts/Nunito-Regular.ttf'
});

function UpdateStudentDetails() {
    const [error, setError] = useState("");
    const [courses, setCourses] = useState([]);
    const [programmes, setProgrammes] = useState([]);
    const [genders, setGenders] = useState([]);
    const [casteCategory, setCasteCategory] = useState([]);
    const [registrationNo, setRegistrationNo] = useState("");
    const [studentDetails, setStudentDetails] = useState({
        socialReservation: '',
    });
    const [lastQualifyingDetails, setLastQualifyingDetails] = useState([]);
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [university, setUniversity] = useState([]);
    const [educationGap, setEducationGap] = useState("");
    const [documents, setDocuments] = useState([]);
    const [nationality, setNationality] = useState([]);
    const [bloodGroup, setBloodGroup] = useState([]);
    const [maritalData, setMaritalData] = useState([]);
    const [religion, setReligion] = useState([]);
    const [socialReservation, setSocialReservation] = useState("");
    const [differentlyAbled, setdifferentlyAbled] = useState("");
    const [inHouse, setinHouse] = useState("");
    const [orphan, setOrphan] = useState("");
    const [exServicemenStudent, setExservivemanStudent] = useState("");
    const [photoUrl, setPhotoUrl] = useState(null);
    const [signUrl, setSignUrl] = useState(null);
    const [subjects, setSubjects] = useState([]);

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;


    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [coursesRes, programmeRes, genderRes, categoryRes, universityResponse,
                    nationalityRes, bloodgroupResponse, maritalResponse, religionResponese
                ] = await Promise.all([
                    getCourse(token),
                    getProgramme(token),
                    getGender(token),
                    getCasteCategory(token),
                    getUniversityboard(token),
                    getNationality(token),
                    getBloodGroup(token),
                    getMaritalData(token),
                    getReligion(token),
                ]);
                setCourses(coursesRes.data);
                setProgrammes(programmeRes.data);
                setGenders(genderRes.data);
                setCasteCategory(categoryRes.data);
                setUniversity(universityResponse.data);
                setNationality(nationalityRes.data);
                setBloodGroup(bloodgroupResponse.data);
                setMaritalData(maritalResponse.data);
                setReligion(religionResponese.data);
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);

    const handleShowClick = async () => {
        if (!registrationNo) {
            toast.error("Please enter a Registration Number");
            return;
        }

        try {
            const response = await getStudentDetails(token, registrationNo);
            console.log("Student Details:", response);
            setStudentDetails({
                lastName: response.data.lastName || "",
                firstName: response.data.firstName || "",
                middleName: response.data.middleName || "",
                courseName: response.data.courseName || "",
                dateOfBirth: response.data.dateOfBirth || "",
                registrationDate: response.data.registrationDate || "",
                genderId: response.data.gender.id || "",
                casteCategoryId: response.data.casteCategory.id || "",
                aadharNo: response.data.aadhaarCardNo || "",
                abcId: response.data.abcID || "",
                mobileNo: response.data.mobileNo || "",
                firstNameUnicode: response.data.firstNameUnicode || "",
                nameAsPerAadhaar: response.data.nameAsPerAadhaar || "",
                nationalityId: response.data.nationality.id || "",
                bloodGroupId: response.data.bloodGroup.id || "",
                socialReservation: response.data.socialReservation || "",
                differentlyAbled: response.data.differentlyAbled || "",
                middleNameUnicode: response.data.middleNameUnicode || "",
                email: response.data.email || "",
                religionId: response.data.religion.id || "",
                birthPlace: response.data.birthPlace || "",
                inHouse: response.data.inHouse || "",
                orphan: response.data.orphan || "",
                lastNameUnicode: response.data.lastNameUnicode || "",
                maritalId: response.data.maritalStatus.id || "",
                udiseNo: response.data.udiseNo || "",
                exServicemenStudent: response.data.exServicemenStudent || "",
                genderName: response.data.gender.genders || "",
                casteCategoryName: response.data.casteCategory.casteCategory || "",
                religionName: response.data.religion.religion || "",
                nationalityName: response.data.nationality.nationality || "",
                bloodGroupName: response.data.bloodGroup.bloodGroup || "",
                maritalStatusName: response.data.maritalStatus.maritalStatus || "",
                
                currentPinCode: response.data.currentPinCode || "",
                currentcityName: response.data.currentCity.name || "",
                currentCountryName: response.data.currentCountry.name || "",
                currentTalukaName: response.data.currentTaluka || "",
                currentStateName: response.data.currentState.name || "",
                currentAddress: response.data.currentAddress || "",
                permanentAddress: response.data.permanentAddress || "",
                permanentpincode: response.data.permanentPinCode || "",
                permanentCityName: response.data.permanentCity.name || "",
                permanentTalukaName: response.data.permanentTaluka || "",
                permanentStateName: response.data.permanentState.name || "",


                fatherName: response.data.fatherName || "",
                fatherNameUnicode: response.data.fatherNameUnicode || "",
                motherName: response.data.motherName || "",
                motherNameUnicode: response.data.motherNameUnicode || "",
                familyMembers: response.data.familyMembers || "",
                annualIncome: response.data.annualIncome || "",
                parentName: response.data.parentName || "",
                parentMobile: response.data.parentMobile || "",
            });
            setSocialReservation(response.data.socialReservation);
            setdifferentlyAbled(response.data.differentlyAbled);
            setinHouse(response.data.inHouse);
            setOrphan(response.data.orphan);
            setExservivemanStudent(response.data.exServicemenStudent);

            const qualifyingResponse = await getLastQualifyingDetails(token, registrationNo, selectedCourseId);
            console.log("last qualifying details", qualifyingResponse);
            setLastQualifyingDetails({
                lastExamName: qualifyingResponse.data.lastExamName || "",
                boardUniversity: qualifyingResponse.data.universityAndBoard.id || "",
                schoolCollege: qualifyingResponse.data.college || "",
                yearOfPassing: qualifyingResponse.data.yearOfPassing || "",
                obtainedMarks: qualifyingResponse.data.obtainedMarks || "",
                totalMarks: qualifyingResponse.data.totalMarks || "",
                percentage: qualifyingResponse.data.percentage || "",
                stream: qualifyingResponse.data.stream || "",
                lastExamSeatNo: qualifyingResponse.data.lastExamSeatNo || "",
                result: qualifyingResponse.data.result || "",
                educationGap: qualifyingResponse.data.gap || "",
            });
            setEducationGap(qualifyingResponse.data.gap);

            const documentResponse = await getDocumentByStudentID(token, registrationNo, selectedCourseId);
            console.log("Document Response", documentResponse);
            if (documentResponse && documentResponse.data) {
                console.log("Document Response Data:", documentResponse.data);
                setDocuments(documentResponse.data);
            } else {
                console.error("Invalid document response:", documentResponse);
                toast.error("Failed to fetch documents");
                setDocuments([]); // Reset to an empty state
            }
            toast.success("Details fetched successfully");
        } catch (error) {
            toast.error("Failed to fetch student details");
            setStudentDetails([]);
        }
    };

    useEffect(() => {
        if (!token || !registrationNo) return; // Ensure valid token and studentId

        const fetchImages = async () => {
            try {
                const photoResponse = await fetchStudentPhoto(token, registrationNo);
                const signResponse = await fetchStudentSign(token, registrationNo);

                console.log("Photo Response:", photoResponse);
                console.log("Sign Response:", signResponse);

                // Extract content type dynamically
                const photoType = photoResponse.headers["content-type"] || "image/jpeg";
                const signType = signResponse.headers["content-type"] || "image/jpeg";

                // Create Blobs dynamically based on detected image type
                const photoBlob = new Blob([photoResponse.data], { type: photoType });
                const signBlob = new Blob([signResponse.data], { type: signType });

                // Convert to Base64 URLs
                const photoBase64 = await blobToDataUrl(photoBlob);
                const signBase64 = await blobToDataUrl(signBlob);

                console.log("Photo URL:", photoBase64);
                console.log("Sign URL:", signBase64);

                setPhotoUrl(photoBase64);
                setSignUrl(signBase64);
            } catch (error) {
                console.error("Error fetching images:", error);
            }
        };

        fetchImages();
    }, [token, registrationNo]);


    useEffect(() => {
        if (!token || !registrationNo || !selectedCourseId) return;
    
        const fetchSubjects = async () => {
            try {
                const response = await fetchSubjectbyStudentID(token, registrationNo, selectedCourseId);
    
                console.log("Full API Response:", response); // Debugging
    
                if (!response || !response.data) {
                    console.error("Error: Response or response.data is undefined.");
                    return;
                }
    
                const { majorDisciplines = [], otherSubjectCategories = [] } = response.data;
    
                console.log("Major Disciplines:", majorDisciplines);
                console.log("Other Subject Categories:", otherSubjectCategories);
    
                // Extract Major Discipline IDs
                const majorDisciplineIds = majorDisciplines.map(md => md.majorDiscipline.id);
                console.log("Major Discipline IDs:", majorDisciplineIds);
    
                // Filter Major and Minor Subjects
                const majorSubjects = otherSubjectCategories
                    .filter(sub => majorDisciplineIds.includes(sub.discipline.id))
                    .map(sub => ({
                        subjectCode: sub.subjectDefinition?.subjectCode || "N/A",
                        subjectName: sub.subjectDefinition?.subjectName || "N/A"
                    }));
    
                    const minorSubjects = otherSubjectCategories
                    .filter(sub => !majorDisciplineIds.includes(sub.discipline.id)) // Ensuring it's not a major subject
                    .map(sub => ({
                        subjectCode: sub.subjectDefinition?.subjectCode || "N/A",
                        subjectName: sub.subjectDefinition?.subjectName || "N/A"
                    }));
    
                console.log("Filtered Major Subjects:", majorSubjects);
                console.log("Filtered Minor Subjects:", minorSubjects);
    
                setSubjects({ majorSubjects, minorSubjects });
            } catch (error) {
                console.error("Error fetching subjects:", error);
            }
        };
    
        fetchSubjects();
    }, [token, registrationNo, selectedCourseId]);
    

    const blobToDataUrl = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const handleDownload = (documentData) => {
        try {
            // Ensure we have access to the DOM
            if (typeof document.createElement !== "function") {
                throw new Error("DOM is not available.");
            }

            if (!documentData || !documentData.documentFile) {
                toast.error("Document file is missing.");
                return;
            }

            const base64Data = documentData.documentFile;
            const sanitizedBase64 = base64Data.replace(/[\s\r\n]+/g, '');

            const byteCharacters = atob(sanitizedBase64);
            const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);

            const contentType = documentData.contentType || 'application/pdf';
            const blob = new Blob([byteArray], { type: contentType });

            const fileName = documentData.fileName || "downloaded_document.pdf";

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(link.href);

        } catch (error) {
            console.error("Download error:", error);
            toast.error("Failed to download document. Check console for details.");
        }
    };

    const handleUpdate = async () => {
        try {
            // Validate input fields before submission
            if (!registrationNo || !selectedCourseId) {
                toast.error("Please enter all mandatory fields.");
                return;
            }

            // Prepare payloads for the APIs
            const studentDetailsPayload = {
                firstName: studentDetails.firstName,
                middleName: studentDetails.middleName,
                lastName: studentDetails.lastName,
                firstNameUnicode: studentDetails.firstNameUnicode,
                middleNameUnicode: studentDetails.middleNameUnicode,
                lastNameUnicode: studentDetails.lastNameUnicode,
                nameAsPerAadhaar: studentDetails.nameAsPerAadhaar,
                aadhaarCardNo: studentDetails.aadharNo,
                abcID: studentDetails.abcId,
                mobileNo: studentDetails.mobileNo,
                email: studentDetails.email,
                genderId: studentDetails.genderId,
                nationalityId: studentDetails.nationalityId,
                religionId: studentDetails.religionId,
                casteCategoryId: studentDetails.casteCategoryId,
                dateOfBirth: studentDetails.dateOfBirth,
                birthPlace: studentDetails.birthPlace,
                maritalStatusId: studentDetails.maritalId,
                bloodGroupId: studentDetails.bloodGroupId,
                // categoryType: studentDetails.selectedCategoryType,
                socialReservation: studentDetails.socialReservation,
                udiseNo: studentDetails.udiseNo,
                inhouse: studentDetails.inHouse,
                exServicemenStudent: studentDetails.exServicemenStudent,
                differentlyAbled: studentDetails.differentlyAbled,
                orphan: studentDetails.orphan,

                fatherName: studentDetails.fatherName,
                fatherNameUnicode: studentDetails.fatherNameUnicode,
                motherName: studentDetails.motherName,
                motherNameUnicode: studentDetails.motherNameUnicode,
                familyMembers: studentDetails.familyMembers,
                annualIncome: studentDetails.annualIncome,
                parentName: studentDetails.parentName,
                parentMobile: studentDetails.parentMobile
            };

            console.log("Update Studentdetails Request", studentDetailsPayload);

            const lastQualifyingPayload = {
                courseId: selectedCourseId,
                lastExamName: lastQualifyingDetails.lastExamName,
                universityAndBoardId: lastQualifyingDetails.boardUniversity,
                college: lastQualifyingDetails.schoolCollege,
                passingYear: lastQualifyingDetails.yearOfPassing,
                obtainedMarks: lastQualifyingDetails.obtainedMarks,
                totalMarks: lastQualifyingDetails.totalMarks,
                percentage: lastQualifyingDetails.percentage,
                stream: lastQualifyingDetails.stream,
                lastExamSeatNo: lastQualifyingDetails.lastExamSeatNo,
                result: lastQualifyingDetails.result,
                gap: educationGap.educationGap,
            };

            console.log("Update lastqualifying Request", lastQualifyingPayload);

            // Call the APIs sequentially
            await updatestudentdetails(studentDetailsPayload, token, registrationNo);
            await updateLastQualifying(lastQualifyingPayload, token, registrationNo);

            toast.success("Student details and last qualifying details updated successfully.");
        } catch (error) {
            console.error("Error updating details:", error);
            toast.error("Failed to update student details.");
        }
    };

    const PDFReport = ({ studentDetails, lastQualifyingDetails, photoUrl, signUrl, documents, subjects }) => {
        const renderHeader = () => (
            <View style={{ flexDirection: "column", borderColor: "black" }}>

                <View >
                    <View style={{ borderBottom: "1px solid #000", width: '100%', textAlign: 'center', marginBottom: 5, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <View style={{ flex: 1, alignItems: 'center', }}>
                            <Text style={{ fontSize: 6, marginBottom: "5px" }}>
                                Maharashtra Education Society's
                            </Text>
                            <Text style={{ fontSize: 10, marginBottom: "5px" }}>
                                MES GARWARE COLLEGE OF COMMERCE (AUTONOMOUS)
                            </Text>
                            <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                                KARVE ROAD, DECCAN GYMKHANA, PUNE - 411004
                            </Text>
                            <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                                Affilated to Savitribai Phule Pune University
                            </Text>
                            <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                                UBI-ID-NO:PU/PN/C/018/(1967)
                            </Text>
                            <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                                NAAC Re-Accredited - 'A' Grade (CGPA - 3.45)
                            </Text>                     <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                                Best College Award By Savitribai Phule Pune University
                            </Text>
                        </View>
                        <View style={{ alignItems: "center", marginRight: 10 }}>

                            <View style={{ padding: 15 }}>
                                {photoUrl ? (
                                    <Image source={{ uri: photoUrl }} style={{ width: 100, height: 100, border: "1px solid black" }} />
                                ) : (
                                    <Text>No Photo Available</Text>
                                )}
                            </View>
                            <View style={{ padding: 10 }}>
                                {signUrl ? (
                                    <Image source={{ uri: signUrl }} style={{ width: 100, height: 50, border: "1px solid black" }} />
                                ) : (
                                    <Text>No Signature Available</Text>
                                )}
                            </View>
                            <View>
                            </View>
                        </View>
                    </View>

                    <View style={{ marginTop: 10, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                        <Text style={{
                            fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4"
                        }}>
                            1. Personal Information Section
                        </Text>

                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1, fontWeight: "700" }}>
                                Last Name:
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                First Name:
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                Middle Name:
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Name of Student:
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {studentDetails.lastName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {studentDetails.firstName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                {studentDetails.middleName || "NA"}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Father's Name: {studentDetails.fatherName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Mother's Name: {studentDetails.motherName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                In-House Student: {studentDetails.inHouse ? "Yes" : "No"}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Date of Birth: {studentDetails.dateOfBirth || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Gender: {studentDetails.genderName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                Aadhar Card No: {studentDetails.aadharNo || "NA"}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Caste Category: {studentDetails.casteCategoryName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Phy. Handicapped: {studentDetails.differentlyAbled ? "Yes" : "No"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                Religion: {studentDetails.religionName || "NA"}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderBottomWidth: 1, }}>
                                Nationality: {studentDetails.nationalityName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderBottomWidth: 1, }}>
                                Birth Place: {studentDetails.birthPlace || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                Is Orphan: {studentDetails.orphan ? "Yes" : "No"}

                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, }}>
                                Annual Income: {studentDetails.annualIncome || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, }}>
                                Blood Group: {studentDetails.bloodGroupName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, }}>
                                Marital Status: {studentDetails.maritalStatusName || "NA"}

                            </Text>
                        </View>

                    </View>

                    <View style={{ marginTop: 5, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            2. Address Details
                        </Text>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Address of Correspondence : {studentDetails.currentAddress || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                                Pin Code : {studentDetails.currentPinCode || "NA"}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                State : {studentDetails.currentStateName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Taluka : {studentDetails.currentTalukaName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                                City : {studentDetails.currentcityName || "NA"}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Permanent Address : {studentDetails.permanentAddress || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                                Pin Code : {studentDetails.permanentpincode || "NA"}
                            </Text>
                        </View>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                                State : {studentDetails.permanenttStateName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                                Taluka : {studentDetails.permanentTalukaName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5 }}>
                                City : {studentDetails.permanentCityName || "NA"}
                            </Text>
                        </View>
                    </View>

                    <View style={{ marginTop: 5, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            3. Contact Details
                        </Text>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Student Mobile No: {studentDetails.mobileNo || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                Parent phone: {studentDetails.parentMobile}
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, }}>
                                Student Email Id: {studentDetails.email}
                            </Text>
                        </View>
                    </View>

                    <View style={{ marginTop: 10, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            4. Qualifying Exam Details Section / lsAppear -
                        </Text>

                        {/* Display Qualifying Exam Name and Stream */}
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 5 }}>
                            <Text style={{ flex: 1, fontSize: 9, textAlign: 'left', padding: 5 }}>
                                QUALIFYING EXAM NAME: {lastQualifyingDetails.lastExamName || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 9, textAlign: 'right', padding: 5 }}>
                                QUALIFYING EXAM STREAM: {lastQualifyingDetails.stream || "NA"}
                            </Text>
                        </View>

                        {/* Table header */}
                        <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5" }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>College/School Attended</Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Board/University</Text>

                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Passing Year</Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Marks Obt</Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Total Marks</Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Percentage</Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Stream</Text>
                            <Text style={{ flex: 0.5, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>Education Gap</Text>
                        </View>

                        {/* Render qualification details */}
                        <View style={{ flexDirection: 'row', borderTopWidth: 1 }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.schoolCollege || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.boardUniversity || "NA"}
                            </Text>

                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.yearOfPassing || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.obtainedMarks || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.totalMarks || "NA"}
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.percentage || "NA"} %
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                {lastQualifyingDetails.stream || "NA"}
                            </Text>
                            <Text style={{ flex: 0.5, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                                {lastQualifyingDetails.educationGap ? "Yes" : "No"}
                            </Text>
                        </View>
                    </View>

                    <View style={{ marginTop: 10, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            5. Document Details -
                        </Text>

                        {/* Display Qualifying Exam Name and Stream */}
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 5 }}>
                            <Text style={{ flex: 1, fontSize: 9, textAlign: 'left', padding: 5 }}>
                                DOCUMENTS:
                            </Text>
                        </View>

                        {/* Table header */}
                        <View style={{

                            flexDirection: 'column',
                            borderWidth: 0.5,
                            borderColor: 'black'
                        }}>

                            {/* Table Header */}
                            <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5", borderBottomWidth: 1 }}>
                                <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, fontWeight: "700" }}>
                                    Sr. No.
                                </Text>
                                <Text style={{ flex: 3, fontSize: 8, padding: 5, fontWeight: "700", borderRightWidth: 1 }}>
                                    Document Name
                                </Text>
                                <Text style={{ flex: 3, fontSize: 8, padding: 5, fontWeight: "700" }}>
                                    Status
                                </Text>
                            </View>

                            {/* Table Rows - Display Document Names */}
                            {documents.length > 0 ? (
                                documents.map((doc, index) => (
                                    <View key={index} style={{ flexDirection: 'row', borderBottomWidth: 1 }}>
                                        <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                                            {index + 1}
                                        </Text>
                                        <Text style={{ flex: 3, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                                            {doc.certificate.certificateName || "NA"}
                                        </Text>
                                        <Text style={{ flex: 3, fontSize: 8, padding: 5, color: "#1565c0" }}>
                                            Attached
                                        </Text>
                                    </View>
                                ))
                            ) : (
                                <Text style={{ fontSize: 8, padding: 5, textAlign: 'center' }}>
                                    No Documents Available
                                </Text>
                            )}
                        </View>

                    </View>

                    <View style={{ marginTop: 10, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            6. Subject Details -
                        </Text>

                        {/* Display Qualifying Exam Name and Stream */}
                        <Text style={{ fontSize: 10, fontWeight: 'bold', marginTop: 5, padding: 5 }}>MAJOR SUBJECTS:</Text>
                        <View style={{
                            flexDirection: 'column',
                            width: 800, 
                            padding: 5
                        }}>
                            <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5", borderBottomWidth: 1 }}>
                                <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, fontWeight: "700", borderLeftWidth: 1 }}>Subject Code</Text>
                                <Text style={{ flex: 4, fontSize: 8, padding: 5, fontWeight: "700",  borderRightWidth: 1 }}>Subject Name</Text>
                            </View>
                            {subjects?.majorSubjects?.map((subject, index) => (
                                <View style={{ flexDirection: 'row', borderBottomWidth: 1 }} key={index}>
                                    <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderLeftWidth: 1 }}>{subject.subjectCode}</Text>
                                    <Text style={{ flex: 4, fontSize: 8, padding: 5, borderRightWidth: 1 }}>{subject.subjectName}</Text>
                                </View>
                            ))}
                        </View>

                        <Text style={{ fontSize: 10, fontWeight: 'bold', marginTop: 5, padding: 5 }}>MINOR SUBJECTS:</Text>
                        <View style={{
                             flexDirection: 'column',
                             width: 800, 
                             padding: 5
                        }}>
                            <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5", borderBottomWidth: 1 }}>
                                <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, fontWeight: "700", borderLeftWidth: 1 }}>Subject Code</Text>
                                <Text style={{ flex: 4, fontSize: 8, padding: 5, fontWeight: "700",  borderRightWidth: 1 }}>Subject Name</Text>
                            </View>
                            {subjects?.minorSubjects?.map((subject, index) => (
                               <View style={{ flexDirection: 'row', borderBottomWidth: 1 }} key={index}>
                              <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderLeftWidth: 1 }}>{subject.subjectCode}</Text>
                              <Text style={{ flex: 4, fontSize: 8, padding: 5, borderRightWidth: 1 }}>{subject.subjectName}</Text>
                           </View>
                            ))}
                        </View>

                    </View>

                    <View style={{ marginTop: 15, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }} >
                            7. Declaration by Student
                        </Text>
                        <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
                            I hereby declare that, I have read the rules related to admission and the information filled in by me in this form is accurate and true to the best of my knowledge. I will be responsible for any discrepancy, arising out of the form signed by me and I undertake that, in absence of any document the final admission will not be granted and/or admission will stand cancel.
                        </Text>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1 }}>
                            <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
                                Place:
                            </Text>


                            <View style={{ alignItems: 'center', padding: 1 }}>
                                {signUrl ? (
                                    <Image source={{ uri: signUrl }} style={{ width: 100, height: 50, border: "1px solid black" }} />
                                ) : (
                                    <Text>No Signature Available</Text>
                                )}
                                <Text style={{ fontSize: 9, textAlign: 'center', marginTop: 2 }}>
                                    Signature of Student
                                </Text>
                            </View>
                        </View>
                    </View>

                    <View style={{ marginTop: 15, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            8. Declaration by Guardian / Parent
                        </Text>
                        <Text
                            style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }} >
                            I have permitted my son/ daughter/ ward to join your college. The information supplied by him/ her is correct to the best of my knowledge. I have acquainted myself with the rules and fees, dues to my son/daughter/ward and see that he/she observes.
                        </Text>

                        <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
                            Place:
                        </Text>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1 }}>
                            <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
                                Date:
                            </Text>
                            <Text style={{ fontSize: 9, textAlign: 'right', marginBottom: 10, padding: 10 }}>
                                Signature of the Guardian/Parent
                            </Text>
                        </View>
                    </View>

                    <View style={{ marginTop: '30', flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            9. For College/ Institute Use Only
                        </Text>
                        <View style={{ flexDirection: 'row' }}>

                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Designation
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Remarks/ Particular/ Recommendation
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                                Signature and Date
                            </Text>
                        </View>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Admission Clerk
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                            </Text>
                        </View>
                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Admission Committee
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                            </Text>
                        </View>
                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Accountant/ cashier
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                            </Text>
                        </View>

                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Registrar/Office superintendent
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                            </Text>
                        </View>
                        <View style={{ flexDirection: 'row', }}>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                Transaction Details
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                <View style={{ flex: 1, padding: 5, borderBottomWidth: 1, borderRightWidth: 1, justifyContent: 'space-between' }}>
                                    <Text style={{ fontSize: 8, marginBottom: 5, alignItems: 'left' }}>
                                        Payment Mode: { }
                                    </Text>
                                    <Text style={{ fontSize: 8, marginBottom: 5, alignItems: 'center' }}>
                                        Cash Received:{ }
                                    </Text>
                                    <Text style={{ fontSize: 8, alignItems: 'right' }}>
                                        Transaction ID: { }
                                    </Text>
                                </View>
                            </Text>
                            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                            </Text>
                        </View>
                    </View>

                    <View style={{ marginTop: 25, borderRightWidth: 0.8, borderTopWidth: 1, borderLeftWidth: 0.8, Padding: 5 }}>
                        <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                            REMARK OF THE ADMISSION COMMITTEE
                        </Text>
                        <View >
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
                                <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 15, padding: 5, marginTop: 10 }}>
                                    May be admitted to Class   ____________________________________________________________________Section_________________________
                                </Text>
                            </View>

                            <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 15, padding: 5 }}>
                                May be Rejected ___________________________________________________________________________________
                            </Text>

                            <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 15, padding: 5 }}>
                                Last date of payment of fees ___________________________________________________________________________________
                            </Text>

                            <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 10, padding: 5 }}>
                                Admission may be cancelled if the fees are not paid by this date.
                            </Text>

                            <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
                                Principal
                            </Text>

                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1, padding: 10 }}>
                                <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, Padding: 10 }} >
                                    Date:
                                </Text>
                                <Text style={{ fontSize: 9, textAlign: 'right', marginBottom: 10, Padding: 10 }}
                                >           Signature of Admission Committee
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        )

        return (
            <Document>
                <Page size="A4" orientation="landscape" style={{ padding: 20 }}>
                    <View>{renderHeader()}</View>
                </Page>
            </Document>
        );

    }


    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Update Student Details</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Course<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Select
                                                value={selectedCourseId}
                                                onChange={(e) => setSelectedCourseId(e.target.value)}
                                                required>
                                                <option value="">Select Course</option>
                                                {courses.map((course) =>
                                                    <option key={course.id} value={course.id}>
                                                        {course.courseName}
                                                    </option>)}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="registrationNo">
                                            Registration No<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control
                                                type="text"
                                                id="registrationNo"
                                                placeholder="Enter Registration Number"
                                                value={registrationNo}
                                                onChange={(e) => setRegistrationNo(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3">
                                    <Button variant="primary" type="button" onClick={handleShowClick}>
                                        Show
                                    </Button>
                                    <Button variant="primary" type="button" style={{ marginLeft: "10px" }} onClick={handleUpdate}>
                                        Update
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}>
                                        Cancel
                                    </Button>
                                    <PDFDownloadLink style={{ marginLeft: "10px" }}
                                        document={<PDFReport
                                            studentDetails={studentDetails}
                                            lastQualifyingDetails={lastQualifyingDetails}
                                            photoUrl={photoUrl}
                                            signUrl={signUrl}
                                            documents={documents}
                                            subjects={subjects}
                                        />}
                                        fileName="Student Details.pdf"
                                        className="btn btn-primary"
                                    >
                                        {({ loading }) => (loading ? 'Loading document...' : 'Report')}
                                    </PDFDownloadLink>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Card className="mt-3">
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Student Details</p>
                        <Form>
                            <Row>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="firstName"
                                                name='firstName'
                                                required
                                                value={studentDetails.firstName}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, firstName: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>First Name Unicode</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name Unicode"
                                                id="firstNameUnicode"
                                                name='firstNameUnicode'
                                                required
                                                value={studentDetails.firstNameUnicode}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, firstNameUnicode: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Name As Per Aadhar</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Name As Per Aadhar"
                                                id="nameAsPerAadhaar"
                                                name='nameAsPerAadhaar'
                                                required
                                                value={studentDetails.nameAsPerAadhaar}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, nameAsPerAadhaar: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Mobile No.</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Mobile No"
                                                id="mobileNo"
                                                name='mobileNo'
                                                required
                                                value={studentDetails.mobileNo}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, mobileNo: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label
                                                htmlFor="courseDropdown">
                                                Nationality
                                            </Form.Label>
                                            <Form.Select
                                                value={studentDetails.nationalityId} // Ensure this matches the gender id
                                                onChange={(e) => setStudentDetails({ ...studentDetails, nationalityId: e.target.value })}
                                                required >
                                                <option value="">Select Nationality</option>
                                                {nationality.map((nationality) =>
                                                    <option key={nationality.id} value={nationality.id}>
                                                        {nationality.nationality}
                                                    </option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Date Of Birth</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Mobile No"
                                                id="dateOfBirth"
                                                name='dateOfBirth'
                                                required
                                                value={studentDetails.dateOfBirth}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, dateOfBirth: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label
                                                htmlFor="courseDropdown">
                                                Blood Group
                                            </Form.Label>
                                            <Form.Select
                                                value={studentDetails.bloodGroupId} // Ensure this matches the gender id
                                                onChange={(e) => setStudentDetails({ ...studentDetails, bloodGroupId: e.target.value })}
                                                required >
                                                <option value="">Select Blood Group</option>
                                                {bloodGroup.map((blood) =>
                                                    <option key={blood.id} value={blood.id}>
                                                        {blood.bloodGroup}
                                                    </option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-2">
                                        <Form.Group className="mb-2 ">
                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Social Reservation<span className="text-danger">*</span></Form.Label>
                                            <div>
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    name="socialReservation"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.socialReservation}
                                                    checked={socialReservation === true} // Check if educationGap is true
                                                    onChange={() => setSocialReservation(true)} // Update state on change
                                                />
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    name="socialReservation"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.socialReservation}
                                                    checked={socialReservation === false} // Check if educationGap is false
                                                    onChange={() => setSocialReservation(false)} // Update state on change
                                                />
                                            </div>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-2">
                                        <Form.Group className="mb-2 ">
                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>differentlyAbled Student<span className="text-danger">*</span></Form.Label>
                                            <div>
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    name="differentlyAbled"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.differentlyAbled}
                                                    checked={differentlyAbled === true} // Check if educationGap is true
                                                    onChange={() => setdifferentlyAbled(true)} // Update state on change
                                                />
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    name="differentlyAbled"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.differentlyAbled}
                                                    checked={differentlyAbled === false} // Check if educationGap is true
                                                    onChange={() => setdifferentlyAbled(false)} // Update state on change
                                                />
                                            </div>
                                        </Form.Group>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>MiddleName</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="firstName"
                                                name='firstName'
                                                required
                                                value={studentDetails.middleName}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, middleName: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>MiddleName Unicode</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="middleNameUnicode"
                                                name='middleNameUnicode'
                                                required
                                                value={studentDetails.middleNameUnicode}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, middleNameUnicode: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Aadhar No.</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="aadharNo"
                                                name='aadharNo'
                                                required
                                                value={studentDetails.aadharNo}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, aadharNo: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="email"
                                                name='email'
                                                required
                                                value={studentDetails.email}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, email: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label
                                                htmlFor="courseDropdown">
                                                Religion
                                            </Form.Label>
                                            <Form.Select
                                                value={studentDetails.religionId} // Ensure this matches the gender id
                                                onChange={(e) => setStudentDetails({ ...studentDetails, religionId: e.target.value })}
                                                required >
                                                <option value="">Select Nationality</option>
                                                {religion.map((data) =>
                                                    <option key={data.id} value={data.id}>
                                                        {data.religion}
                                                    </option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Birth Place</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="birthPlace"
                                                name='birthPlace'
                                                required
                                                value={studentDetails.birthPlace}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, birthPlace: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-2">
                                        <Form.Group className="mb-2 ">
                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Inhouse Student<span className="text-danger">*</span></Form.Label>
                                            <div>
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    name="inHouse"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.inHouse}
                                                    checked={inHouse === true} // Check if educationGap is true
                                                    onChange={() => setinHouse(true)} // Update state on change
                                                />
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    name="inHouse"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.inHouse}
                                                    checked={inHouse === false}
                                                    onChange={() => setinHouse(false)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-2">
                                        <Form.Group className="mb-2 ">
                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Orphan Student<span className="text-danger">*</span></Form.Label>
                                            <div>
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    name="orphan"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.orphan}
                                                    checked={orphan === true} // Check if educationGap is true
                                                    onChange={() => setOrphan(true)}
                                                />
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    name="orphan"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.orphan}
                                                    checked={orphan === false} // Check if educationGap is true
                                                    onChange={() => setOrphan(false)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Row>

                                </Col>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>lastName</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="firstName"
                                                name='firstName'
                                                required
                                                value={studentDetails.lastName}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, lastName: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>lastName Unicode</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="lastNameUnicode"
                                                name='lastNameUnicode'
                                                required
                                                value={studentDetails.lastNameUnicode}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, lastNameUnicode: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>ABC Id</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="abcId"
                                                name='abcId'
                                                required
                                                value={studentDetails.abcId}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, abcId: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label
                                                htmlFor="courseDropdown">
                                                Gender
                                            </Form.Label>
                                            <Form.Select
                                                value={studentDetails.genderId} // Ensure this matches the gender id
                                                onChange={(e) => setStudentDetails({ ...studentDetails, genderId: e.target.value })}
                                                required >
                                                <option value="">Select Gender</option>
                                                {genders.map((gender) =>
                                                    <option key={gender.id} value={gender.id}>
                                                        {gender.genders}
                                                    </option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Caste Category
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Select
                                                value={studentDetails.casteCategoryId} // Ensure this matches the gender id
                                                onChange={(e) => setStudentDetails({ ...studentDetails, casteCategoryId: e.target.value })}
                                                required>
                                                <option value="">Select Caste Category</option>
                                                {casteCategory.map((category) =>
                                                    <option key={category.id} value={category.id}>
                                                        {category.casteCategory}
                                                    </option>)}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Marital Status
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Select
                                                value={studentDetails.maritalId} // Ensure this matches the gender id
                                                onChange={(e) => setStudentDetails({ ...studentDetails, maritalId: e.target.value })}
                                                required>
                                                <option value="">Select Marital Status</option>
                                                {maritalData.map((data) =>
                                                    <option key={data.id} value={data.id}>
                                                        {data.maritalStatus}
                                                    </option>)}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>UDISE No.</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="udiseNo"
                                                name='udiseNo'
                                                required
                                                value={studentDetails.udiseNo}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, udiseNo: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-2">
                                        <Form.Group className="mb-2 ">
                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Ex Serviceman Student<span className="text-danger">*</span></Form.Label>
                                            <div>
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    name="exServicemenStudent"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.exServicemenStudent}
                                                    checked={exServicemenStudent === true} // Check if educationGap is true
                                                    onChange={() => setExservivemanStudent(true)}
                                                />
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    name="exServicemenStudent"
                                                    type="radio"
                                                    id="inline-radio-1"
                                                    value={studentDetails.exServicemenStudent}
                                                    checked={exServicemenStudent === false} // Check if educationGap is true
                                                    onChange={() => setExservivemanStudent(false)}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>


                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Family Details</p>
                        <Form>
                            <Row>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Father Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="fatherName"
                                                name='fatherName'
                                                required
                                                value={studentDetails.fatherName}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, fatherName: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Mother Name Unicode</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="motherNameUnicode"
                                                name='motherNameUnicode'
                                                required
                                                value={studentDetails.motherNameUnicode}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, motherNameUnicode: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Parent Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="parentName"
                                                name='parentName'
                                                required
                                                value={studentDetails.parentName}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, parentName: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Father Name Unicode</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="fatherNameUnicode"
                                                name='fatherNameUnicode'
                                                required
                                                value={studentDetails.fatherNameUnicode}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, fatherNameUnicode: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Total Family Members</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="familyMembers"
                                                name='familyMembers'
                                                required
                                                value={studentDetails.familyMembers}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, familyMembers: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Parent Mobile No.</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="parentMobile"
                                                name='parentMobile'
                                                required
                                                value={studentDetails.parentMobile}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, parentMobile: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Mother Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="motherName"
                                                name='motherName'
                                                required
                                                value={studentDetails.motherName}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, motherName: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Family Annual Income</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name"
                                                id="annualIncome"
                                                name='annualIncome'
                                                required
                                                value={studentDetails.annualIncome}
                                                onChange={(e) => setStudentDetails({ ...studentDetails, annualIncome: e.target.value })} />
                                        </Form.Group>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>

                <Card className="mt-3">
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Last Qualifying Exam Details</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Last Exam Name
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.lastExamName}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, lastExamName: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Board/University
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Select
                                                value={lastQualifyingDetails.boardUniversity} // Ensure this matches the gender id
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, boardUniversity: e.target.value })}
                                                required>
                                                <option value="">Select University</option>
                                                {university.map((data) => (
                                                    <option key={data.id} value={data.id}>
                                                        {data.universityBoardName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            School/College
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.schoolCollege}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, schoolCollege: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Year Of Passing
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Select required>
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Obtained Marks
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.obtainedMarks}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, obtainedMarks: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Total Marks
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.totalMarks}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, totalMarks: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Percentage
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.percentage}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, percentage: e.target.value })} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Stream
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.stream}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, stream: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Last Exam Seat No.
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.lastExamSeatNo}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, lastExamSeatNo: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Result
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                value={lastQualifyingDetails.result}
                                                onChange={(e) => setLastQualifyingDetails({ ...lastQualifyingDetails, result: e.target.value })} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">Education Gap<span className="text-danger">*</span></Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Check
                                                inline
                                                label="Yes"
                                                name="group1"
                                                type="radio"
                                                id="inline-radio-1"
                                                className="me-3"
                                                value={lastQualifyingDetails.educationGap}
                                                checked={educationGap === true} // Check if educationGap is true
                                                onChange={() => setEducationGap(true)} // Update state on change
                                            />
                                            <Form.Check
                                                inline
                                                label="No"
                                                name="group1"
                                                type="radio"
                                                id="inline-radio-2"
                                                checked={educationGap === false} // Check if educationGap is false
                                                onChange={() => setEducationGap(false)} // Update state on change
                                            />
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Card className="mt-3">
                    <CardBody>
                        <Table>
                            <thead>
                                <th>Name Of Document</th>
                                <th>Download</th>
                            </thead>
                            <tbody>
                                {documents.length > 0 ? (
                                    documents.map((doc) => (
                                        <tr key={doc.id}>
                                            <td>{doc.certificate?.certificateName || "N/A"}</td>
                                            <td>
                                                <Button
                                                    variant="link"
                                                    onClick={() => handleDownload(doc)}
                                                >
                                                    Download
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={2}>No documents found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>


        </>
    );
}

export default UpdateStudentDetails;